import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPagedListItem } from '../../../typings/generated/careerhub-client';

interface ListItemInfoState {
    modalIsOpen: boolean,
    item?: IPagedListItem
}

const initialState: ListItemInfoState = {
    modalIsOpen: false,
};

export const listItemInfoSlice = createSlice({
    initialState: initialState,
    name: 'list-item-info',
    reducers: {
        setModalOpen(state, action: PayloadAction<{ item: IPagedListItem }>) {
            state.modalIsOpen = true;
            state.item = action.payload.item;
        },
        setModalClose(state) {
            state.modalIsOpen = false;
            state.item = undefined;
        },
    },
});

export const {
    setModalOpen,
    setModalClose,
} = listItemInfoSlice.actions;
